module.exports = __webpack_public_path__ + "static/secu-00c8c5f8bbf0570dfc34438257762a31.jpeg";